import { render, staticRenderFns } from "./btn-arrow-tertiary.vue?vue&type=template&id=a6061b14&scoped=true&"
import script from "./btn-arrow-tertiary.vue?vue&type=script&lang=js&"
export * from "./btn-arrow-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6061b14",
  null
  
)

export default component.exports